import { Box, BoxProps, ModalDialogNew, Spacer, TextNew, TextNewProps } from '@jfs/ui-new'
import { default as React } from 'react'

interface AepsAlertDialogProps {
  show: boolean
  text: string
  onOkPress: any
  onCancelPress: any
  postitiveButtonText: string
  negativeButtonText: string
}

export const AepsAlertDialog = ({
  show,
  text,
  onOkPress,
  onCancelPress,
  postitiveButtonText,
  negativeButtonText,
}: AepsAlertDialogProps) => {
  return (
    <ModalDialogNew show={show} type="centeredWrap">
      <Box {...styles.container}>
        <TextNew {...styles.bodyText}>{text}</TextNew>
        <Spacer direction="vertical" size={40} />
        <Box {...styles.buttonParentContainer}>
          <Box underlayColor={'GREY_WHITE'} flex={1} alignItems="center" padding={15} onPress={onCancelPress}>
            <TextNew fontSize={14} color={'BLACK_75'} fontFamily="jioType-medium">
              {negativeButtonText}
            </TextNew>
          </Box>
          <Box width={'1px'} backgroundColor="BORDER_COLOR" height={'100%'}></Box>
          <Box underlayColor={'GREY_WHITE'} flex={1} alignItems="center" padding={15} onPress={onOkPress}>
            <TextNew fontSize={14} color={'BLACK_75'} fontFamily="jioType-medium">
              {postitiveButtonText}
            </TextNew>
          </Box>
        </Box>
      </Box>
    </ModalDialogNew>
  )
}

const styles = {
  container: {
    borderRadius: 8,
    width: '90vw',
    paddingTop: 40,
    paddingHorizontal: 30,
    alignItems: 'center',
  } as BoxProps,
  bodyText: {
    fontSize: 16,
    lineHeight: 25,
    color: 'BLACK_21',
    fontFamily: 'jioType-medium',
  } as TextNewProps,
  buttonParentContainer: {
    direction: 'row',
    width: '100%',
    borderTopWidth: 1,
    borderTopColor: 'BORDER_COLOR',
  } as BoxProps,
}
